(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruu-hero"] && !Shopify.designMode) return;
  try {
    
  /* Slider de fondo: cambia de foto con fade. Se detiene si la persona prefiere menos movimiento
     o si la pestaña no está visible. En el editor de temas sigue rotando y se pausa mientras
     hay una foto seleccionada en la barra lateral. */
  if (!customElements.get('ruu-hero-slides')) {
    customElements.define(
      'ruu-hero-slides',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.ruu-hero__slide')];
          this.index = 0;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.canPlay = this.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;
          this.addEventListener('shopify:block:select', (e) => {
            this.stop();
            this.show(this.slides.indexOf(e.target.closest('.ruu-hero__slide')));
          });
          this.addEventListener('shopify:block:deselect', () => this.start());
          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        start() {
          this.stop();
          if (!this.canPlay) return;
          this.timer = setInterval(() => {
            if (!document.hidden) this.show(this.index + 1);
          }, Number(this.dataset.interval) || 5000);
        }

        stop() {
          clearInterval(this.timer);
        }

        show(i) {
          if (i < 0) return;
          this.index = i % this.slides.length;
          this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === this.index));
        }
      }
    );
  }

  /* Menú móvil: abre y cierra el panel con animación (también al tocar el fondo oscuro, un enlace o Esc). */
  if (!window.ruuHeroMenuReady) {
    window.ruuHeroMenuReady = true;

    const closeMenu = (dialog) => {
      if (!dialog.open || dialog.dataset.closing) return;
      dialog.dataset.closing = 'true';
      dialog.classList.remove('is-open');
      const done = () => {
        delete dialog.dataset.closing;
        dialog.close();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else setTimeout(done, 500);
    };

    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-ruu-menu-open]');
      if (open) {
        const dialog = open.parentElement.querySelector('dialog');
        dialog.showModal();
        // Dos fotogramas para que el navegador pinte el estado cerrado antes de animar la apertura
        requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-open')));
        return;
      }
      const dialog = e.target.closest('.ruu-hero__menu-dialog');
      if (dialog && (e.target === dialog || e.target.closest('[data-ruu-menu-close], a'))) closeMenu(dialog);
    });

    // Esc: se cierra con la misma animación
    document.addEventListener(
      'cancel',
      (e) => {
        const dialog = e.target.closest ? e.target.closest('.ruu-hero__menu-dialog') : null;
        if (!dialog) return;
        e.preventDefault();
        closeMenu(dialog);
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruu-products"] && !Shopify.designMode) return;
  try {
    
  /* Latas: tres lugares (izquierda, centro, derecha). Al avanzar, cada lata se mueve por su cuenta
     al lugar siguiente y las frutas (con su piso) se cambian en su sitio con un desenfoque.
     Cambia solo: el primer cambio llega ~1 s después de que la sección se ve, para que se note que
     está animada; luego cada N segundos (se pausa fuera de pantalla, con el cursor encima o con
     "reducir movimiento"),
     al tocar una lata del lado y al deslizar el dedo. En el editor muestra el bloque elegido. */
  if (!customElements.get('ruu-products-slides')) {
    customElements.define(
      'ruu-products-slides',
      class extends HTMLElement {
        connectedCallback() {
          this.cans = [...this.querySelectorAll('.ruu-products__can')];
          this.fruits = [...this.querySelectorAll('.ruu-products__fruit')];
          this.grounds = [...this.querySelectorAll('.ruu-products__ground')];
          this.shadows = [...this.querySelectorAll('.ruu-products__shadow')];
          this.index = 0;
          this.played = false;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.canPlay = this.dataset.autoplay === 'true' && !reduce && this.cans.length > 1;
          // Mientras corre un cambio (≈1.9 s) no se acepta otro: clics, swipes y autoplay esperan.
          this.lockMs = reduce ? 0 : 1950;
          this.busy = false;
          const section = this.closest('.ruu-products');

          this.cans.forEach((can, i) =>
            can.addEventListener('click', () => {
              if (this.goTo(i)) this.start(this.interval);
            })
          );

          let startX = null;
          section.addEventListener('pointerdown', (e) => (startX = e.clientX));
          section.addEventListener('pointerup', (e) => {
            if (startX === null) return;
            const dx = e.clientX - startX;
            startX = null;
            if (Math.abs(dx) < 50) return;
            if (this.goTo(this.index + (dx < 0 ? 1 : -1))) this.start(this.interval);
          });
          section.addEventListener('pointercancel', () => (startX = null));
          section.addEventListener('pointerenter', () => this.start(this.interval));
          section.addEventListener('pointerleave', () => this.start(this.interval));

          this.addEventListener('shopify:block:select', (e) => {
            this.stop();
            this.goTo(this.cans.indexOf(e.target.closest('.ruu-products__can')), true);
          });
          this.addEventListener('shopify:block:deselect', () => this.start(this.interval));

          this.interval = Number(this.dataset.interval) || 4000;
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            if (!entry.isIntersecting) this.stop();
            else if (!this.timer) this.start(this.played ? this.interval : 1000);
          });
          this.observer.observe(this);

          // Carga y decodifica todas las imágenes antes de que la sección entre en pantalla,
          // para que ningún cambio de versión se vea a medias por una imagen que aún no está lista.
          const preload = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              preload.disconnect();
              this.querySelectorAll('img').forEach((img) => {
                img.loading = 'eager';
                img.decode?.().catch(() => {});
              });
            },
            { rootMargin: '100% 0px' }
          );
          preload.observe(this);
          this.preload = preload;
        }

        disconnectedCallback() {
          this.stop();
          clearTimeout(this.busyTimer);
          this.observer?.disconnect();
          this.preload?.disconnect();
        }

        start(delay = this.interval) {
          this.stop();
          if (!this.canPlay) return;
          this.timer = setTimeout(() => {
            this.timer = null;
            if (!document.hidden && this.goTo(this.index + 1)) this.played = true;
            this.start(this.interval);
          }, delay);
        }

        stop() {
          clearTimeout(this.timer);
          this.timer = null;
        }

        /** Va a la versión i. Devuelve false si no hizo nada (ya está ahí o hay un cambio en curso). */
        goTo(i, force = false) {
          const n = this.cans.length;
          if (this.busy && !force) return false;
          if (i < 0 && i !== -1) return false;
          const next = ((i % n) + n) % n;
          if (next === this.index) return false;
          this.index = next;
          if (this.lockMs) {
            this.busy = true;
            this.classList.add('is-busy');
            clearTimeout(this.busyTimer);
            this.busyTimer = setTimeout(() => {
              this.busy = false;
              this.classList.remove('is-busy');
            }, this.lockMs);
          }
          this.cans.forEach((can, k) => {
            const d = (k - next + n) % n;
            const slot = d === 0 ? 'c' : d === 1 ? 'l' : d === n - 1 ? 'r' : 'hidden';
            const prev = can.dataset.slot;
            if ((prev === 'l' && slot === 'r') || (prev === 'r' && slot === 'l')) {
              can.classList.add('is-wrapping');
              clearTimeout(can.wrapTimer);
              can.wrapTimer = setTimeout(() => can.classList.remove('is-wrapping'), 1300);
            }
            can.dataset.slot = slot;
            if (this.shadows[k]) this.shadows[k].dataset.slot = slot;
            if (slot === 'c') can.setAttribute('aria-current', 'true');
            else can.removeAttribute('aria-current');
          });
          [...this.fruits, ...this.grounds].forEach((el) => el.classList.toggle('is-active', Number(el.dataset.index) === next));
          return true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruu-way"] && !Shopify.designMode) return;
  try {
    
  /*
    Carrusel de fotos en móvil: cambia solo cada cierto tiempo, también al deslizar.
    En escritorio las fotos van en fila y este elemento no hace nada.
  */
  if (!customElements.get('ruu-way-photos')) {
    class RuuWayPhotos extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.index = 0;
        this.visible = false;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplay = this.dataset.autoplay !== 'false';

        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);

        this.mobile.addEventListener('change', () => this.schedule(), { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });

        let startX = 0;
        this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true, signal });
        this.addEventListener('touchend', (event) => {
          const dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) >= 50) this.goTo(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true, signal });

        // Editor de temas: al seleccionar un bloque se muestra su foto
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides().indexOf(event.target.closest('.ruu-way__photo'));
          if (i > -1) this.goTo(i);
        }, { signal });

        this.schedule();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
      }

      slides() {
        return [...this.querySelectorAll('.ruu-way__photo:not(.ruu-way__photo--desktop-only)')];
      }

      goTo(next) {
        const slides = this.slides();
        if (slides.length < 2) return;
        this.index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        const canRun = this.autoplay && this.mobile.matches && this.visible && !document.hidden && !this.reduced.matches;
        if (canRun && this.slides().length > 1) this.timer = setTimeout(() => this.goTo(this.index + 1), this.interval);
      }
    }

    customElements.define('ruu-way-photos', RuuWayPhotos);
  }

  } catch(e) { console.error(e); }
})();
})();
